$('.hpe-tabs__button').click(function () {
  const tabNumber = $(this).attr('data-tab');
  const activeClass = 'hpe-tabs__section--active';
  $(this)
    .attr('aria-selected', true)
    .siblings()
    .removeAttr('aria-selected');

  $(`[data-tab-section='${tabNumber}']`)
    .addClass(activeClass)
    .siblings()
    .removeClass(activeClass);
});

$('.hpe-tabs__control').change(function () {
  const tabNumber = $(this).attr('data-tab');
  const activeClass = 'hpe-tabs__section--active';
  $(`[data-tab-section='${tabNumber}']`)
    .addClass(activeClass)
    .siblings()
    .removeClass(activeClass);
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/tabs.js